import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "home"
  }, [_vm._v(" " + _vm._s(_vm.$t('title')) + " "), _c('router-link', {
    attrs: {
      "to": _vm.$config.homeUrl
    }
  }, [_vm._v(_vm._s(_vm.t('返回主页')))])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };